import { create } from "zustand"

import "../graphql/invoiceList.query"
import type { InvoicesSearchParams } from "../schemas"

import {
  GetInvoiceListDocument,
  type GetInvoiceListQuery,
  type Invoice,
  type InvoiceListInput,
} from "@/graphql/codegen/graphql"
import { createSearchStore } from "@/stores/createSearchStore"

export const deduplicateInvoices = (newRows: Invoice[], existing: Invoice[]): Invoice[] => {
  const seen = new Set(existing.map((invoice) => invoice.invoiceId))
  return [...existing, ...newRows.filter((invoice) => !seen.has(invoice.invoiceId))]
}

export const getInvoicesSearchInput = (
  filters: InvoicesSearchParams,
  offset: number,
  limit: number
): InvoiceListInput => {
  const { field, order, query, statuses, invoiceType, vendorCompanyId } = filters

  return {
    offset,
    limit,
    sort: field && order ? { field, order } : undefined,
    filter: {
      query: query || undefined,
      statuses: statuses?.length ? statuses : undefined,
      invoiceType: invoiceType ?? undefined,
      vendorCompanyId: vendorCompanyId || undefined,
    },
  }
}

export const useInvoicesSearchStore = create(
  createSearchStore<Invoice, InvoicesSearchParams, GetInvoiceListQuery>({
    documentNode: GetInvoiceListDocument,
    deduplicateData: deduplicateInvoices,

    getQueryInput: getInvoicesSearchInput,

    getQueryVariables: (queryInput) => ({ input: queryInput }),

    extractDataFromResponse: (data) => {
      const result = data.invoice.list
      if (result.__typename !== "InvoiceListSuccess") {
        return {
          __typename: result.__typename,
          data: [],
          error: result.__typename === "InvoiceListFailure" ? result.error : undefined,
        }
      }
      return {
        __typename: result.__typename,
        data: result.invoices as Invoice[],
      }
    },
  })
)
